module.exports = __webpack_public_path__ + "static/media/shopping-bag.12b6ad5a.svg";